export default __webpack_public_path__ + "static/media/logoNVIDIA_lastone.4e60cfe3.png";